































































































































import { Component, Vue, Emit } from 'vue-property-decorator'
import { Message } from 'element-ui'
import $Api from '@api'
import { LoanRepaymentDetail } from '@/api/model/repayment'
import { finalize } from 'rxjs/operators'
import { translate } from '@/utils/filters'
import BlockTitle from '@/components/common/BlockTitle.vue'

@Component({
    components: {
        BlockTitle
    }
})
export default class extends Vue {
    detailList: any = {}
    recordList: any = []
    substractList: any = []

    shouldLoading = false
    shouldLoadingSubstract = false

    updateRemarkFormVisible = false
    detailId = 0
    remark = ''

    created(): void {
        this.loadRepayment()
        this.loadSubpay()
    }

    loadSubpay() {
        const { index, lid, rid } = this.$route.query
        this.shouldLoadingSubstract = true
        $Api.repaymentService
            .queryRepaymentSubstract({
                index: +index,
                lid: +lid
            })
            .pipe(
                finalize(() => {
                    this.shouldLoadingSubstract = false
                })
            )
            .subscribe(res => {
                if (res) {
                    this.substractList = res
                }
            })
    }

    loadRepayment() {
        const { index, lid, rid } = this.$route.query
        this.shouldLoading = true
        $Api.repaymentService
            .queryRepaymentDetail({
                index: +index,
                lid: +lid,
                rid: +rid
            })
            .pipe(
                finalize(() => {
                    this.shouldLoading = false                   
                })
            )
            .subscribe(res => {
                this.detailList = res.partRepaymentResponse
                if (res.list) {
                    this.recordList = res.list
                }
            })
    }

    updateRemark(row: LoanRepaymentDetail): void {
        this.updateRemarkFormVisible = true
        this.detailId = row.id
    }

    @Emit('close')
    handleClose(): void {
        this.updateRemarkFormVisible = false
    }

    @Emit('refresh')
    handleRefresh(): void {}

    onManualSubmit(): void {
        $Api.repaymentService
            .updateRepaymentDetailRemark({
                id: this.detailId,
                remark: this.remark
            })
            .subscribe(
                data => {
                    Message.success(translate('repayment.unpaidDetail.recordList.updateRemark.success') as string)
                    this.handleClose()
                    this.handleRefresh()
                    this.loadRepayment()
                },
                error => {
                    Message.error(error.message)
                }
            )
    }
}
